module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns h-100 background-image d-flex flex-grow-1"
  }, [_c('div', {
    staticClass: "column is-8-tablet is-offset-2-tablet is-6-desktop is-offset-3-desktop is-4-fullhd is-offset-4-fullhd"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0c92db32"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuthContainer.vue
// module id = 978
// module chunks = 0